import { render, staticRenderFns } from "./PropertySetting.vue?vue&type=template&id=ea4a2ada&"
import script from "./PropertySetting.vue?vue&type=script&lang=ts&"
export * from "./PropertySetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports